import { getRepubPath, isValidRepub } from '@cx-web/utils';

/**
 * Extracts the path from a URL, excluding the repub segment
 * @param repub - The repub code (e.g., 'US', 'DE', 'OC')
 * @param requestUrl - The full request URL
 * @returns The path excluding repub (e.g., 'casino/real-money-casinos')
 */
export function getPathExcludingRepubFromUrl(repub: string | undefined, requestUrl: string): string {
  // Handle undefined repub - throw error
  if (!repub) {
    throw new Error('repub is undefined');
  }

  // Validate repub is a valid repub code
  if (!isValidRepub(repub)) {
    throw new Error('repub not valid');
  }

  // Get the repub path with leading slash format (e.g., '/us', '/de', or '' for root)
  const repubPath = getRepubPath(repub);

  // Parse the URL to get the pathname, search, and hash
  const url = new URL(requestUrl);
  let pathname = url.pathname;

  // If repub has a path (not root), remove it from the pathname
  if (repubPath) {
    // Remove the repub path and any leading slash
    if (pathname.startsWith(repubPath)) {
      pathname = pathname.slice(repubPath.length);
    }
  }

  // Remove leading slash if present
  const pathWithoutSlash = pathname.startsWith('/') ? pathname.slice(1) : pathname;

  // Include search and hash if present
  return pathWithoutSlash + url.search + url.hash;
}

// {repub: "US", requestUrl: "https://spor-1332.ephem.stg.occloud.io/us/casino/real-money-casinos", path: "casino/real-money-casinos"}
// {repub: "US", requestUrl: "http://localhost:3001/us/casino/real-money-casinos", path: "casino/real-money-casinos"}
// {repub: "US", requestUrl: "https://spor-1332.ephem.stg.occloud.io/us/casino/no-deposit-bonus", path: "casino/no-deposit-bonus"}
// {repub: "US", requestUrl: "https://spor-1332.ephem.stg.occloud.io/us/casino", path: "casino"}
// {repub: "US", requestUrl: "http://localhost:3000/us/casino", path: "casino"}
